import type { AppEnvType } from '../app-env';
import { buildDevUrls, buildLocalUrls, buildProductionUrls, buildStagingUrls } from '../helpers';

export interface IUrlVars {
  webUrl: string;
  loginUrl: string;
  identityUrl: string;
  apiUrl: string;
  cookieDomain: string | undefined;
  passkeyDomain: string;
  allowedOrigins: string[];
  exploreUrl: string;
  vaultUrl: string;
  vaultApiKey: string;
  telegramUrl: string;
}

export const urlVars: Record<AppEnvType, IUrlVars> = {
  local: buildLocalUrls(),
  dev: buildDevUrls(),
  stg: buildStagingUrls(),
  prod: buildProductionUrls(),
};
